/**
 * Roadmap — the full journey to a California Class A license, so the knowledge
 * tests sit in context. Copy is verbatim from the design.
 */
import { PageHeader, Card } from './TrainingUI';

const STEPS: [string, string][] = [
  [
    'Meet the basics',
    "Hold a valid California driver's license and be 18+. You must be 21 to drive interstate (across state lines) or haul hazardous materials — most trucking jobs effectively require 21.",
  ],
  [
    'Pass a DOT medical exam',
    "A DOT-approved medical examiner completes a Medical Examination Report and gives you a Medical Examiner's Certificate (Form MCSA-5876). The DMV needs this on file before issuing your permit.",
  ],
  [
    'Apply at the DMV',
    "Complete the commercial driver's license application (DL 44C), bring proof of identity, Social Security number, and California residency, and pay the application fee (roughly $100 — verify current amount).",
  ],
  [
    "Pass the knowledge tests — this app's job",
    'Three written tests for Class A with air brakes: General Knowledge (50 questions, 40 to pass), Air Brakes (25 questions, 20 to pass), and Combination Vehicles (20 questions, 16 to pass). You get a maximum of 3 attempts per test before the application is voided, so arrive over-prepared.',
  ],
  [
    "Get your Commercial Learner's Permit (CLP)",
    "Passing the knowledge tests earns your CLP. It's valid for 180 days (renewable once) and you must hold it at least 14 days before taking the skills test. With a CLP you can drive a commercial vehicle only with a CDL holder beside you.",
  ],
  [
    'Complete Entry-Level Driver Training (ELDT)',
    'Federal law requires training from a provider listed on the FMCSA Training Provider Registry before your skills test — theory plus behind-the-wheel. California also has its own minimum behind-the-wheel hours requirement for Class A.',
  ],
  [
    'Pass the 3-part skills test',
    "Vehicle inspection (walk-around, naming parts and defects), basic control skills (straight-line backing, offset backing, parallel parking), and the road test. Taken in a representative Class A vehicle — test in an automatic and you'll carry an automatic-only restriction.",
  ],
  [
    'Walk out with your Class A',
    "Pass everything, pay remaining fees, and you're a commercial driver. Keep your medical certificate current — it expires (typically every 2 years) and an expired card downgrades your CDL.",
  ],
];

const TIPS = [
  'Make an appointment — commercial test windows fill up.',
  'You can take all three knowledge tests the same day; if one goes badly you can stop and return another day for that one.',
  'Read every question fully — DMV answers often differ by one word ("should" vs "must", "only" vs "also").',
  "The tests are drawn from the handbook, not from trick trivia. If you consistently score 90%+ in this app's exam simulator, you're ready.",
];

export function Roadmap() {
  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader
        title="Your road to a California Class A"
        sub="The full journey, so the knowledge tests fit into context. Details and fees change — confirm current requirements at dmv.ca.gov before each step."
      />
      <Card>
        {STEPS.map(([h, p], i) => (
          <div key={h} className="roadstep">
            <div className="num">{i + 1}</div>
            <div>
              <h4>{h}</h4>
              <p>{p}</p>
            </div>
          </div>
        ))}
      </Card>

      <Card className="mt-4">
        <h3 className="">Test-day tips</h3>
        <ul className="lesson-body" style={{ marginLeft: '1.1rem', listStyle: 'disc' }}>
          {TIPS.map((t) => (
            <li key={t}>{t}</li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
